const TYPE = "grupo";

const grupoProdutoModule = {
  findAll: async (dbConnection, limite = null) => {
    let grupos = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
       // status: { $eq: "A" },
      },
      limit: 9999
    });

    if (result.docs.length) {
      grupos = result.docs;
    }

    return grupos;
  },
};

export default grupoProdutoModule;
